import DOMPurify from "dompurify";

export default defineNuxtPlugin(() => {
  const sanitize = (dirty, cfg) => DOMPurify.sanitize(dirty || "", cfg);
  return { provide: { sanitize } };
});
